// 关注用户
import loading from 'c-up-loading';
import events from '../../base/events';
import { followAdd, followDelete} from '@js/service';

let Follow = function() {};

Follow.prototype = Object.assign({}, {

    do(fuid) {
        fuid = (typeof fuid == 'string') ? Number(fuid) : fuid;
        followAdd({
            params: { fuid }
        }).then(res => {
            if (res.code == 1) {
                loading.hide();
                this.emit('followSuccess', fuid);
            }
        }).catch(() => {
            loading.hide();
        })
    },

    unFollow(fuid) {
        followDelete({
            params: { fuid }
        }).then(res => {
            if (res.code == 1) {
                this.emit('unFollowSuccess');
            }
        }).catch(() => {
            loading.hide();
        })
    }

}, events);

export default Follow;



// WEBPACK FOOTER //
// ./js/component/follow/index.js